/*
  AUTHOR - KHYATI RADADIYA
  COMPANY NAME - RADIX ANALYTICS
  Version - 1
  Change log
    -----------------------------------------------------------------------
    Date         Author   Comment
    -----------------------------------------------------------------------
    2024-07-10	  Khyati   This is upload video in offline mode action file
*/

import {
  VIDEO_UPLOAD_REQUEST,
  VIDEO_UPLOAD_SUCCESS,
  VIDEO_UPLOAD_FAILURE,
} from "../types";
import axiosInstance from "../../services/axiosInstance";
import { formDataHeader } from "../../services/auth-header";
import recreateAccessTokenAction from "../auth/RecreateAccessTokenAction";

const VideoUploadAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: VIDEO_UPLOAD_REQUEST,
    });
    axiosInstance
      .post(`v1/upload_video_score_process/`, data, {
        headers: formDataHeader(),
      })
      .then((response) => {
        dispatch({
          type: VIDEO_UPLOAD_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: VIDEO_UPLOAD_FAILURE,
          payload: error.message,
        });
        if (error.message === "Request failed with satus code 403") {
          dispatch(recreateAccessTokenAction());
        }
      });
  };
};

export default VideoUploadAction;
